import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-upload-file-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M10.1738 14.8332H5.82714C2.55381 14.8332 1.15381 13.4332 1.15381 10.1599V10.0732C1.15381 7.11319 2.32048 5.68652 4.93381 5.43985C5.20048 5.41985 5.45381 5.61985 5.48048 5.89319C5.50714 6.16652 5.30714 6.41319 5.02714 6.43985C2.93381 6.63319 2.15381 7.61985 2.15381 10.0799V10.1665C2.15381 12.8799 3.11381 13.8399 5.82714 13.8399H10.1738C12.8871 13.8399 13.8471 12.8799 13.8471 10.1665V10.0799C13.8471 7.60652 13.0538 6.61985 10.9205 6.43985C10.6471 6.41319 10.4405 6.17319 10.4671 5.89985C10.4938 5.62652 10.7271 5.41985 11.0071 5.44652C13.6605 5.67319 14.8471 7.10652 14.8471 10.0865V10.1732C14.8471 13.4332 13.4471 14.8332 10.1738 14.8332Z"
        fill="currentColor" />
      <path
        d="M8 10.4998C7.72667 10.4998 7.5 10.2731 7.5 9.99975V2.41309C7.5 2.13975 7.72667 1.91309 8 1.91309C8.27333 1.91309 8.5 2.13975 8.5 2.41309V9.99975C8.5 10.2731 8.27333 10.4998 8 10.4998Z"
        fill="currentColor" />
      <path
        d="M10.2336 4.39964C10.1069 4.39964 9.98022 4.35297 9.88022 4.25297L8.00022 2.37297L6.12022 4.25297C5.92689 4.4463 5.60689 4.4463 5.41355 4.25297C5.22022 4.05964 5.22022 3.73964 5.41355 3.5463L7.64689 1.31297C7.84022 1.11964 8.16022 1.11964 8.35355 1.31297L10.5869 3.5463C10.7802 3.73964 10.7802 4.05964 10.5869 4.25297C10.4936 4.35297 10.3602 4.39964 10.2336 4.39964Z"
        fill="currentColor" />
    </svg>
  `,
})
export class UploadFileIconComponent extends BaseIconComponent {
  override width = input<string>('16');
  override height = input<string>('16');
  override viewBox = input<string>('0 0 16 16');
}
